import api from './api';
export const authService = {
    signup(data) {
        return api.post('/api/auth/signup', data);
    },
    adminSignup(data) {
        return api.post('/api/auth/admin/signup', data);
    },
    login(credentials) {
        return api.post('/api/auth/login', credentials);
    },
    sendVerificationEmail(data) {
        return api.post('/api/auth/send-email', data);
    },
    verifyEmail(token) {
        return api.get(`/api/auth/verify-email?token=${token.token}`);
    },
    verifyToken() {
        return api.get('/api/auth/verify');
    },
    logout() {
        return api.post('/api/auth/logout');
    },
};
